<h2 class="complete-profile-title">
  <button class="cursor-pointer hover:text-primary" (click)="onBack.emit()"><i class="fa-light fa-square-arrow-left text-3xl"></i></button>

  Upload Extra Images
</h2>
@if (uploading()) {
  <div class="bg-green-100 px-4 py-2 mb-4">
    <i class="fa fa-spinner animate-spin"></i> Uploading Images
  </div>
}
<div class="grid grid-cols-4 gap-4">
  @for (img of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]; track $index) {
    <div class="min-h-36 relative overflow-hidden bg-white border rounded-3xl border-gray-200 center-all cursor-pointer" (click)="select()">
      @if (this.images().length >= img) {
        <app-resized-image [src]="this.images()[img - 1]" [width]="400" [height]="400"></app-resized-image>
        <button (click)="deleteImage(this.images()[img - 1]);$event.stopPropagation() " class="absolute bottom-0 right-0 py-1 no-unerline bg-red-600  size-8 rounded-full no-underline center-all m-2 text-white text-center">
          <i class="fa fa-times"></i>
        </button>
      } @else {
        <span class="size-8 center-all bg-primary rounded">
        <i class="fa fa-plus text-white"></i>
          </span>
      }
    </div>
  }
</div>
<div class="flex gap-4 items-center py-8">
  <label for="pvt">Make images visible to matched users only</label>
  <p-toggle-switch inputId="pvt" [(ngModel)]="isPrivate" (onChange)="updatePrivacy()"></p-toggle-switch>
</div>
<button class="btn-base w-full bg-primary text-white" (click)="saved.emit()">
  @if (standalone()) {
    Save
  } @else {
    NEXT
  }</button>

<input
  #fileInput2
  type="file"
  style="display: none;"
  accept=".jpg,.jpeg,.png,image/jpeg,image/png"
  multiple
  maxlength="9"
  (change)="onFileSelected($event)"
/>
